import { useParkingFeeBasicList } from '@services/parkingFee'
import { Select, SelectProps } from '@shared/Form/Select'
import { useTranslation } from 'react-i18next'

type Props = SelectProps

export const ParkingFeeCitySelect = (props: Props) => {
  const { t } = useTranslation()

  const { data, isLoading } = useParkingFeeBasicList()

  return (
    <Select loading={isLoading} {...props}>
      {data.map(x => (
        <Select.Option key={x.id} value={x.sessionId}>
          {x.sessionName}
        </Select.Option>
      ))}
    </Select>
  )
}

export default ParkingFeeCitySelect
